import { Component, inject } from '@angular/core';

import { AppService } from '@services/app.services';
import { MainCartService } from '@services/main-cart.service';

import { ModalComponent } from '@shared/modal/modal.component';
import { ModalTypes } from '@shared/modal/modal.interface';

@Component({
    selector: 'checkout-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrl: 'error-modal.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class ErrorModalComponent extends ModalComponent {
    type: ModalTypes = 'error';
    title: string = "Quelque chose nous empêche d'afficher cette page";
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur',
        categorieClic: 'Modale_erreur',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Me_faire_rappeler',
        categorieClic: 'Modale_erreur',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur',
    };

    private cartService = inject(MainCartService);
    private appService = inject(AppService);

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this.onCloseHandler();
        });
    }

    private onCloseHandler(): void {
        let errorUrl: string = '/rappelez-moi';
        const type = this.cartService.getQuote().isAcquisitionFix() ? 'tlvctcfai10' : 'tlvctcmobile10';
        errorUrl += `?callback=${type}`;
        this.appService.navigateTo(errorUrl);
    }
}
